import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const mediaDefinition: ComponentDefinition = {
  id: 'media',
  name: 'Media',
  category: 'Media',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/image.svg',
  variables: {
    entryId: {
      displayName: 'Entry ID',
      type: 'Text',
      group: 'content',
      description: 'Paste a Media entry ID.',
      validations: { bindingSourceType: ['manual'] },
    },
  },
} as const;
